import axios from 'axios'
import fontColorContrast from 'font-color-contrast'
import React, { useState, useEffect, useRef } from 'react'
import { Col, Form, Row, Spinner, Alert } from 'react-bootstrap'
import { useForm } from "react-hook-form"
import ReactInputMask from 'react-input-mask'
import { checkList, fetchBlackList, isIterableArray, useClientInfo } from '../../block-slider/utils'


const MAX_FILE_SIZE = 15 * 1024 * 1024
const MAX_FILE_SIZE_TITLE = '15 MB'

const TypeForm = ({ data, page_id, pageData }) => {
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
    } = useForm()

    const elRef = useRef()


    // const params = new URLSearchParams(window.location.hash);


    // const query = queryString.parse(window.location.hash)
    // const { receipt, number_card } = query
    // console.log(query, window.location.hash.substring(1), params)
    const hash = window.location.hash.substring(1)


    const [isScroll, setIsScroll] = useState(false)

    useEffect(() => {
        if (isScroll) return
        setIsScroll(true)
        if (hash && hash === 'toform' && !!elRef?.current?.offsetTop) {
            const offsetTop = elRef.current.offsetTop
            const windowHeight = window?.innerHeight || 0
            const top = offsetTop + windowHeight - 100
            window.scrollTo({
                top: top,
                behavior: 'smooth',
            })
        }
    }, [hash, isScroll])


    const { emails, text_on_success, text_button, text_under, button_color } = data.setting


    const [isLoading, setIsLoading] = useState(false); // загрузка при отправке
    const [isAlertSuccess, setIsAlertSuccess] = useState(false);
    const [isAlertError, setIsAlertError] = useState(false);
    const [isAlertErrorSize, setIsAlertErrorSize] = useState(false);

    const [fileList, setFileList] = useState({});

    const [itemsData, setItemsData] = useState({
        agreeCheckbox: [],
        checkboxs: [],
        inputs: [],
        buttons: []
    });

    const [blackList, setBlackList] = useState(null)
    useEffect(() => {
        fetchBlackList(8).then(res => {
            setBlackList(res)
        })
    }, [])

    useEffect(() => {
        if (data) {
            dataToFormat(data.items)
        }
    }, [data]);


    // форматируем данные. делим поля на чекбоксы, текстовые инпуты и кнопки 
    // каждому инпуту задаю fieldName который потом используется для формирования данных для отправки
    const dataToFormat = (data) => {
        const checkboxItems = data.reduce((acc, item, index) => {
            if (item.type === 1) acc.push({
                ...item,
                fieldName: `checkbox_${index} `,
            })
            return acc
        }, [])
        const inputItems = data.reduce((acc, item, index) => {
            if (item.type > 1 && item.type < 7) acc.push({
                ...item,
                fieldName: `input_${index} `,
            })
            return acc
        }, [])
        const buttonsItems = data.reduce((acc, item, index) => {
            if (item.type > 6 && item.type !== 11) acc.push({
                ...item,
                fieldName: `file_${index} `,
            })
            return acc
        }, [])
        const agreeCheckboxItems = data.reduce((acc, item, index) => {
            if (item.type === 11) acc.push({
                ...item,
                fieldName: `agree_${index} `,
            })
            return acc
        }, [])
        setItemsData({
            agreeCheckbox: agreeCheckboxItems,
            checkboxs: checkboxItems,
            inputs: inputItems,
            buttons: buttonsItems
        })

    }


    const onSubmit = (formData) => {
        const formatter = (arr) => {
            return arr.reduce((acc, item) => {
                const val = {
                    forEmail: item.forEmail,
                    value: formData[item.fieldName]
                }
                if (item.value_rkn) val.value_rkn = item.value_rkn
                acc.push(val)
                return acc
            }, [])
        }

        const formattedCheckboxs = formatter(itemsData.checkboxs)
        const formattedInputs = formatter(itemsData.inputs)
        // const formattedButtonts = formatter(itemsData.buttons)

        const sendData = {
            checkboxs: formattedCheckboxs,
            inputs: formattedInputs,
        }

        handleSend(sendData)
    }

    const { fetchClientInfo } = useClientInfo()


    const handleSend = async (sendData) => {

        const files = Object.keys(fileList).map(key => (fileList[key]))
        const info = await fetchClientInfo()
        const formData = new FormData()

        formData.append('data', JSON.stringify(sendData))
        formData.append('clientInfo', JSON.stringify({
            ...info,
            page_name: pageData.name_rkn,
            form_name: data.name_rkn,
        }))
        formData.append('emails', JSON.stringify(emails))
        formData.append('page_id', page_id)

        if (isIterableArray(files)) {
            files.map(filekey => {
                if (isIterableArray(filekey)) {
                    filekey.map(file => {
                        formData.append('files[]', file)
                    })
                }
            })

        }

        setIsLoading(true)

        axios
            .post(`${process.env.REACT_APP_API_BASE} /pages/send - email`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((response) => {
                if (response?.data && response.data?.res) {
                    if (response.data.res === 'Success')
                        setIsAlertSuccess(true)
                    if (response.data.res === 'Error')
                        setIsAlertError(true)
                }
                reset()
            })
            .catch((err) => {
                console.log(err)
                setIsAlertError(true)
            })
            .finally(() => {
                setIsLoading(false)
            });
    }



    const RenderFormItems = ({ items }) => (
        items.map((item, key) => {
            switch (item.type) {
                case 1: return <CheckboxItem key={key} item={item} />
                case 2: return TextCol(item)
                case 3: return TextCol(item)
                case 4: return PhoneCol(item)
                case 5: return EmailCol(item)
                case 6: return CommentCol(item)
                case 7: return <FileInput
                    key={key}
                    item={item}
                />
                case 8: return <FileDownload key={key} item={item} />

                case 11: return <CheckboxAgreeItem key={key} item={item} />

                default: return '';
            }
        })
    )

    const CheckboxItem = ({ item }) => (
        <Col className='mb-2'>
            <Form.Check
                type="checkbox"
                label={<span dangerouslySetInnerHTML={{ __html: item.text }} />}
                id={item.fieldName}
                {...register(item.fieldName)}
            />
        </Col>
    )
    const CheckboxAgreeItem = ({ item }) => (
        <Col className='mb-2'>
            <Form.Check
                type="checkbox"
                label={<span dangerouslySetInnerHTML={{ __html: item.text }} />}
                id={item.fieldName}
                {...register(item.fieldName, { required: true })}
            />
            {
                errors[item.fieldName] &&
                <Form.Control.Feedback type="invalid" className='d-block'>
                    Обязательно к заполнению
                </Form.Control.Feedback>
            }
        </Col>
    )
    const TextCol = (item) => (
        <Col md={item.type === 2 ? 6 : 12} className='mb-2' key={item.fieldName}>
            <Form.Control
                placeholder={item.text}
                type="text"
                {...register(item.fieldName, { required: !!item.required })}
            />
            {
                errors[item.fieldName] &&
                <Form.Control.Feedback type="invalid" className='d-block'>
                    Обязательно к заполнению
                </Form.Control.Feedback>
            }
        </Col>
    )
    const PhoneCol = (item) => (
        <Col md={6} className='mb-2' key={item.fieldName}>
            <Form.Control
                as={ReactInputMask}
                mask="+7(999)-999-9999"
                type="text"
                placeholder={item.text || 'Телефон'}
                defaultValue={'+7'}
                {...register(item.fieldName, { pattern: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/g })}
            />
            {
                errors[item.fieldName]?.type === 'pattern' &&
                <Form.Control.Feedback type="invalid" className='d-block'>
                    Телефон заполнен некорректно
                </Form.Control.Feedback>
            }
        </Col>
    )
    const EmailCol = (item) => (
        <Col md={6} className='mb-2' key={item.fieldName}>
            <Form.Control
                placeholder={item.text || 'E-mail'}
                type="email"
                {...register(item.fieldName, {
                    required: true,
                    validate: (value) => {
                        return !checkList(blackList, value)
                    },
                })}
            />
            {
                errors?.[item.fieldName]?.type === 'required' &&
                <Form.Control.Feedback type="invalid" className='d-block'>
                    E-mail обязателен к заполнению
                </Form.Control.Feedback>
            }
            {
                errors?.[item.fieldName]?.type === "validate" &&
                <Form.Control.Feedback type="invalid" className='d-block'>
                    {blackList?.text || "Недопустимое значение E-mail"}
                </Form.Control.Feedback>
            }
        </Col>
    )
    const CommentCol = (item) => (
        <Col className='mb-2' key={item.fieldName}>
            <Form.Control
                placeholder={item.text || 'Комментарий'}
                rows={3}
                as="textarea"
                {...register(item.fieldName)}
            />
        </Col>
    )

    const sizeToMB = size => {
        if (size) return (size / 1000000).toFixed(2) + ' ' + 'Mb'
        return ''
    }

    const FileInput = ({ item }) => (
        <div className='mb-2'>

            <div className='btn-add-file'>
                <label htmlFor={item.fieldName} className='d-flex flex-column align-items-start'>

                    <div className='d-flex flex-column pl-3 my-2 ' style={{ borderLeft: "2px solid #969da345" }}>
                        {
                            fileList?.[item.fieldName] ?
                                Object.keys(fileList?.[item.fieldName]).map(key => {
                                    const itemw = fileList?.[item.fieldName][key]
                                    return <div key={key} className='my-2 d-flex align-items-center' style={{ gap: 6 }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px"><path d="M 6 2 C 4.9057453 2 4 2.9057453 4 4 L 4 20 C 4 21.094255 4.9057453 22 6 22 L 18 22 C 19.094255 22 20 21.094255 20 20 L 20 8 L 14 2 L 6 2 z M 6 4 L 13 4 L 13 9 L 18 9 L 18 20 L 6 20 L 6 4 z" /></svg>
                                        <span>{itemw.name}, </span>
                                        <span className='text-muted opacity-70' style={{ opacity: .75 }}>{sizeToMB(itemw.size)}</span>
                                        <span className='ml-3 text-danger' onClick={(e) => {
                                            e.stopPropagation()
                                            e.preventDefault()
                                            const filter = (prev, key) => {
                                                const f = Array.from(prev).map((i, k) => {
                                                    if (k != key) return i
                                                }).filter(i => !!i)
                                                return f
                                            }
                                            setFileList(prev => ({
                                                ...prev,
                                                [item.fieldName]: filter(prev[item.fieldName], key)
                                            }))
                                        }}>
                                            Удалить
                                        </span>
                                    </div>
                                })
                                :
                                ''
                        }
                    </div>
                    <div className='d-flex items-center'>
                        {
                            item.icon &&
                            <img className='mr-2' src={process.env.REACT_APP_BACKEND + '/uploads/pages/blocks/' + item.icon} alt='' />
                        }
                        {
                            item.text
                        }
                    </div>
                </label>

                <Form.Control
                    type='file'
                    multiple
                    id={item.fieldName}
                    accept='.doc,.docx,.txt.,image/*,.pdf'
                    onChange={e => {
                        e.persist()
                        const files = Array.from(e.target.files).map(i => {
                            if (i.size > MAX_FILE_SIZE) {
                                setIsAlertErrorSize(true)
                            }
                            else {
                                return i
                            }
                        }).filter(i => !!i) || []

                        const newFiles = fileList[item.fieldName] ? [...fileList[item.fieldName], ...files] : files

                        setFileList(prev => ({
                            ...prev,
                            [item.fieldName]: newFiles
                        }))
                        setValue(item.fieldName, newFiles)
                    }}
                />
            </div>
        </div>
    )
    const FileDownload = ({ item }) => (
        <div className='mb-2'>
            <div className='btn-download'>
                <a target='_blank' href={process.env.REACT_APP_BACKEND + item.file}>
                    {
                        item.icon &&
                        <img src={process.env.REACT_APP_BACKEND + '/uploads/pages/blocks/' + item.icon} alt='' />
                    }
                    {item.text}
                </a>
            </div>
        </div>
    )

    return (
        <div className='buildedPage-type_8' id='toform' ref={elRef}>

            {data.title && <div className='title' dangerouslySetInnerHTML={{ __html: data.title }} />}


            <form onSubmit={handleSubmit(onSubmit)} >

                <div className='buildedPage-type_8-form'>
                    {
                        isAlertSuccess &&
                        <Alert variant={'success'} onClose={() => setIsAlertSuccess(false)} dismissible>
                            <div dangerouslySetInnerHTML={{ __html: text_on_success }} />
                        </Alert>
                    }
                    {
                        isAlertError &&
                        <Alert variant={'danger'} onClose={() => setIsAlertError(false)} dismissible>
                            <Alert.Heading style={{ fontSize: '1.15rem' }}>Ошибка при отправке</Alert.Heading>
                            <p className='mb-0'>Что-то пошло не так</p>
                        </Alert>
                    }
                    {
                        isAlertErrorSize &&
                        <Alert variant={'danger'} onClose={() => setIsAlertErrorSize(false)} dismissible>
                            <p className='mb-0'>Макс размер файла {MAX_FILE_SIZE_TITLE}</p>
                        </Alert>
                    }
                    <Row>
                        {
                            isIterableArray(itemsData.checkboxs) &&
                            <RenderFormItems items={itemsData.checkboxs} />
                        }
                    </Row>
                    <Row>
                        {
                            isIterableArray(itemsData.inputs) &&
                            <RenderFormItems items={itemsData.inputs} />
                        }
                    </Row>

                    <Row className='mt-3'>
                        <Col md={6} lg={7} xxl={8}>
                            {
                                isIterableArray(itemsData.buttons) &&
                                <RenderFormItems items={itemsData.buttons} />
                            }
                            {
                                isIterableArray(itemsData.agreeCheckbox) &&
                                <RenderFormItems items={itemsData.agreeCheckbox} />
                            }
                        </Col>
                        <Col md={6} lg={5} xxl={4}>
                            <button
                                className='btn btn-submit'
                                type='submit'
                                style={{
                                    backgroundColor: button_color,
                                    color: fontColorContrast(button_color)
                                }}
                            >
                                {
                                    isLoading ?
                                        <Spinner animation='border' />
                                        :
                                        <div dangerouslySetInnerHTML={{ __html: text_button }}></div>
                                }
                            </button>

                            {
                                text_under &&
                                <div className='text_under mt-3' dangerouslySetInnerHTML={{ __html: text_under }} />
                            }
                        </Col>
                    </Row>
                </div>

            </form>
        </div >
    )
}

export default TypeForm
